import { Component, OnInit, EventEmitter ,Input} from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
// import {Familiar} from '../../../models/familiar';
import {Personal} from '../../../models/personal';
import {generalService} from '../../../services/general.service';
import { DataService } from '../../../utils/data.service';
import { modalComponent } from '../../../utils/modal/modal.component';
import { MatDialog } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'my-bitacora-addedit',
  styles: [],
  templateUrl: 'bitacora-addedit.component.html',
  providers: [generalService]
})

export class BitacoraAddEditComponent implements OnInit {
 
 @Input() bitacora:any;
  personal:Personal;
  bitacoraForm: FormGroup;
  titulo = "Agregar";
  list: any;


  constructor(
    private formBuilder: FormBuilder, 
    private _generalService: generalService, 
    public dialog: MatDialog, 
    public dataService: DataService, 
    private route: ActivatedRoute) 
  { 
    this.bitacora = new Object();
    this.personal = new Personal();
    this.list = new Object();  
  }

  ngOnInit() {
    this.buildForm();
    this.getInit(this.dataService.idPersonal);

    if(this.dataService.isUpdate){
      this.titulo = "Editar";
      this.bitacora.TRANSACTION_ID = this.dataService.id;
      this.getBitacora(this.bitacora.TRANSACTION_ID);
    }
  }

  getInit(id:any){
    let params: any = {};
    params.id = id;
    params.loacs = sessionStorage.getItem("acslo");
    this._generalService.metodoCallParams(params, `bitacora/getInit/`).subscribe(
      result => {            
        let res = JSON.parse(result);        
        this.personal.NAME = res.Table[0].NAME;
        this.personal.LAST_NAME = res.Table[0].LAST_NAME;
        this.personal.MOTHER_LAST_NAME = res.Table[0].MOTHER_LAST_NAME;
        this.list.Type = res.Table1;
        this.list.Customer = res.Table2;
        },
      error => {
        console.log(<any>error);
      }
    );
  }

   // getBitacora(id:any){

   // }

  getBitacora(id:any){
      this._generalService.metodoCall(`bitacora/consultarBitacora/${id}`).subscribe(
        result => {
          let res = JSON.parse(result);// this.familiar = JSON.parse(result.replace("[", "").replace("]", ""));     
          this.bitacora = res[0];
           // let fechas = this.familiar.fecha.split("/");
          // this.familiar.fecha = new Date(fechas[2], fechas[1] - 1, fechas[0]);     
        },
        error => {
          var errorMsj = <any>error;
          console.log(errorMsj);
        }
      );
  }

  checkRegisterType(elem:any){
    this.bitacora.TYPE = elem.value;
    let lookupCode = this.list.Type.filter(x => x.LOOKUP_ID == elem.value)[0].LOOKUP_CODE;
    this.bitacora.CUSTOMER_COMPLAINT = (lookupCode == "CUSTOMER_COMPLAINT");
    if(this.bitacora.CUSTOMER_COMPLAINT)
      this.bitacora.CUSTOMER_ID = null;
  }

  buildForm() {
    this.bitacoraForm = this.formBuilder.group({
      personalNombre: [{disabled:true}],//this.formBuilder.control(null),
      personalPaterno: this.formBuilder.control(null),
      personalMaterno: this.formBuilder.control(null),
      TYPE: this.formBuilder.control(null, [Validators.required]),
      CUSTOMER_ID: this.formBuilder.control(null),
      COMMENTS: this.formBuilder.control(null, [Validators.required, Validators.maxLength(1000)]),
    });
    this.bitacoraForm.get('personalNombre').disable();
    this.bitacoraForm.get('personalPaterno').disable();
    this.bitacoraForm.get('personalMaterno').disable();

  }

  cerrarModal(){
    this.dataService.dialogRef.close();
  }

  createBitacora(){
    this._generalService.metodoCallParams(this.bitacora, "bitacora/agregarBitacora").subscribe(
          result => {
            this._generalService.toastCall(result.message);
          },
          error => {
            console.log(<any>error);
          }
      ); 
  }

  updateBitacora(){
    this._generalService.metodoCallParams(this.bitacora, "bitacora/actualizarBitacora").subscribe(
          result => {
            this._generalService.toastCall(result.message);
          },
          error => {
            console.log(<any>error);
          }
      ); 
  }

  onSubmit() {
    this.bitacora.PERSON_ID = this.dataService.idPersonal; 
    if(this.dataService.isUpdate)
      this.updateBitacora();
    else
      this.createBitacora();
    this.cerrarModal();
  }
}


// WEBPACK FOOTER //
// ./src/app/personal/bitacora/agregar-editar/bitacora-addedit.component.ts